<div class="preferences__header">
  <ng-container *ngIf="locations?.length > 1">
      <span
        class="preferences__name"
        data-cy="dashboard-location-preferences.header">
        {{ 'Location preferences for' | translate }}
      </span>

    <div>
      <mat-form-field
        appearance="fill"
        class="mat-form-field--no-label mat-form-field--no-errors select-city">
        <mat-select
          (selectionChange)="update($event)"
          [(ngModel)]="location"
          class="select-location">
          <mat-option
            *ngFor="let location of locations"
            [value]="location">
            {{ location }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </ng-container>

  <ng-container *ngIf="locations?.length <= 1">
      <span
        class="preferences__name"
        data-cy="dashboard-location-preferences.header">
        {{ 'Location preferences' | translate }}
      </span>
    <div></div>
  </ng-container>

  <div class="preferences__actions">
    <div
      (click)="showList()"
      *ngIf="showChart$ | async"
      class="action-button"
      data-cy="dashboard-location-preferences.show-list">
      <span>{{'List' | translate}}</span>
      <mat-icon>list</mat-icon>
    </div>

    <div
      (click)="showChart()"
      *ngIf="showList$ | async"
      class="action-button"
      data-cy="dashboard-location-preferences.show-chart">
      <span>{{'Chart' | translate}}</span>
      <mat-icon>bar_chart</mat-icon>
    </div>
  </div>
</div>
